import React, { PureComponent } from "react";

import { momentModule } from "../../utils/Utils";
import CalendarCell from "./CalendarCell";

const { moment, formatDate } = momentModule;

class CalendarDay extends PureComponent {
  render() {
    const { weekdayIdx, weekday, NUMBER_OF_CELLS } = this.props.config;

    const isWithinRange = startTime =>
      this.props.weekday === weekday.toLowerCase() &&
      moment(startTime).isBetween(this.props.startTime, this.props.stopTime, "minute", "[)");
    const onMouseDown = (e, startTime, value) =>
      this.props.onMouseDown(e, weekdayIdx, startTime, value);

    const cells = [];
    const time = moment({ hour: 0, minute: 0 }); // 00:00h
    for (let i = 0; i < NUMBER_OF_CELLS; i++) {
      let startTime = moment(time); // time
      time.add(15, "minutes");
      let stopTime = moment(time); // time + 15 min
      const timeSchedule = this.props.schedule?.scheduleTime?.find(
        schedule => schedule.startTime === formatDate(startTime, "time")
      );

      if (timeSchedule) {
        const scheduleStart = moment(timeSchedule.startTime, "HH:mm");
        const scheduleStop = moment(timeSchedule.stopTime, "HH:mm");

        // when stopTime is the same or before startTime, it should be the next day
        // or else duration is negative
        if (scheduleStop.isSameOrBefore(scheduleStart, "minute")) {
          scheduleStop.add(1, "day");
        }

        // calculate duration between start and stop schedules
        const scheduleDuration = moment.duration(scheduleStop.diff(scheduleStart));
        const scheduleDurationInMin = scheduleDuration.asMinutes();

        // calculate the number of cells that the schedule includes
        const cellUnitsInDuration = scheduleDurationInMin / 15;

        // create an array with the number of cells and
        // map a CalendarCell for each spot with the respective start and stop times
        const cellsToAdd = [...Array(cellUnitsInDuration)].map((_, idx) => {
          if (idx !== 0) {
            startTime.add(15, "minutes");
            stopTime.add(15, "minutes");
          }

          return (
            <CalendarCell
              key={formatDate(startTime, "time")}
              startTime={moment(startTime)}
              stopTime={moment(stopTime)}
              value={timeSchedule.value}
              withinRange={isWithinRange(startTime)}
              onMouseDown={onMouseDown}
              onMouseMove={this.props.onMouseMove}
              onMouseUp={this.props.onMouseUp}
              onClick={this.props.onClick}
            />
          );
        });

        // finally add to cells to be rendered
        cells.push(cellsToAdd);

        // update time and for index to pass the cells that were already added
        time.add(15 * (cellUnitsInDuration - 1), "minutes");
        i += cellUnitsInDuration - 1;
      } else {
        cells.push(
          <CalendarCell
            key={formatDate(startTime, "time")}
            startTime={moment(startTime)}
            stopTime={moment(stopTime)}
            withinRange={isWithinRange(startTime)}
            onMouseDown={onMouseDown}
            onMouseMove={this.props.onMouseMove}
            onMouseUp={this.props.onMouseUp}
            onClick={this.props.onClick}
          />
        );
      }
    }

    return (
      <div id="calendarDay">
        <p className={`day-title ${weekdayIdx === 0 ? "cover" : ""}`}>
          {moment().day(weekdayIdx).format("dddd")}
        </p>
        <div className="calendar-column">{cells}</div>
      </div>
    );
  }
}

export default CalendarDay;
